import { useRequiredContext } from "@redotech/react-util/context";
import { SELECTABLE_ATTRIBUTION_WINDOWS } from "@redotech/redo-marketing-common/analytics-attribution-filters";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import {
  RedoListItem,
  TextRedoListItem,
} from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo, useMemo } from "react";

/** Undefined keeps each evidence type's saved window. */
type AttributionFilterValue =
  | (typeof SELECTABLE_ATTRIBUTION_WINDOWS)[number]
  | undefined;

const windowOptions: TextRedoListItem<AttributionFilterValue>[] = [
  { id: "saved", type: "text", text: "From settings", value: undefined },
  ...SELECTABLE_ATTRIBUTION_WINDOWS.map(
    (value): TextRedoListItem<AttributionFilterValue> => ({
      id: value,
      type: "text",
      text: `${value} days`,
      value,
    }),
  ),
];

export const MarketingAttributionFilter = memo(
  function MarketingAttributionFilter({
    attributionFilter,
    setAttributionFilter,
  }: {
    attributionFilter: number | undefined;
    setAttributionFilter: (value: number | undefined) => void;
  }) {
    const routes = useRequiredContext(MerchantRoutesContext);
    // A section, so picking it opens the settings instead of changing the filter.
    const options = useMemo(
      (): RedoListItem<AttributionFilterValue>[] => [
        ...windowOptions,
        {
          id: "settings",
          type: "section",
          text: "Edit attribution settings",
          externalLink: routes.getSettingsSubRoute("attribution"),
          value: undefined,
        },
      ],
      [routes],
    );
    return (
      <RedoSingleSelectDropdownInput
        fitToAnchor={false}
        flexGrow={false}
        label="Attribution"
        options={options}
        optionSelected={({ item }) => setAttributionFilter(item.value)}
        selectedItem={windowOptions.find(
          (option) => option.value === attributionFilter,
        )}
        size="xs"
      />
    );
  },
);
